import { render, staticRenderFns } from "./contact-relation-categories.vue?vue&type=template&id=eea609f4&scoped=true&"
import script from "./contact-relation-categories.ts?vue&type=script&lang=ts&"
export * from "./contact-relation-categories.ts?vue&type=script&lang=ts&"
import style0 from "./contact-relation-categories.scss?vue&type=style&index=0&id=eea609f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea609f4",
  null
  
)

export default component.exports